"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LaunchDarkly;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBroadcast = require("react-broadcast");

var _LaunchDarkly = require("../constants/LaunchDarkly");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LaunchDarkly(props) {
  var clientId = props.clientId,
      user = props.user,
      children = props.children,
      clientOptions = props.clientOptions;


  var config = null;

  // if clientId or user do not exist we still want to
  // render the Broadcast component but we want value
  // to be null.
  if (clientId && user) {
    config = {
      clientId: clientId,
      user: user,
      clientOptions: clientOptions
    };
  }

  return _react2.default.createElement(
    _reactBroadcast.Broadcast,
    { channel: _LaunchDarkly.BROADCAST_CHANNEL, value: config },
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/components/LaunchDarkly.js
// module id = 1138
// module chunks = 0